/**
 * 腾讯域：「更新 USER_TOKEN」扫码授权 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.tencent.dtos.user_token_auth 对齐。
 *   - GET /api/v1/tencent/user-token/qrcode → 授权链接 + 二维码 base64 PNG
 *     （任意登录用户可读；config.json#platforms.tx_user_token_redirect_uri
 *     未配置时后端返回 400 + suggestion）
 */

import { request } from "../apiClient";

/** 「更新 USER_TOKEN」扫码授权出参（与后端 UserTokenAuthQrDTO 对齐）。 */
export interface UserTokenAuthQr {
  /** 腾讯平台通用组件授权链接（含 UrlEncode 后的 redirect_uri），微信扫码进入实名认证。 */
  authorize_url: string;
  /** 授权链接二维码的 base64 PNG 字节流；以 data:image/png;base64, 前缀内联渲染。 */
  qr_png_base64: string;
}

/** 生成「更新 USER_TOKEN」扫码授权二维码；redirect_uri 未配置时后端 400 + suggestion。 */
export async function getUserTokenAuthQr(): Promise<UserTokenAuthQr> {
  return request<UserTokenAuthQr>("/api/v1/tencent/user-token/qrcode");
}
